<template>
  <div class="professional-drivers-license-component">
    <div class="service-header mb-2 d-flex align-items-center justify-content-between">
      <div>
        <h6 class="fs-6 fw-semibold text-dark mb-1 mt-0">Professional Driver's License Check</h6>
        <p class="text-xs text-muted mb-0 lh-sm">
          Verify professional driving permits and commercial driver qualifications.
        </p>
      </div>
    </div>
    
    <div class="row g-2">
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary">Please provide the type of PDP (Professional Drivers Permit)? <span class="text-danger">*</span></label>
        <select 
          class="form-select form-select-sm text-xs"
          v-model="professional_drivers_license_data.pdp_type_code"
        >
          <option value="" hidden>Select PDP type</option>
          <option value="DG">Dangerous Goods</option>
          <option value="G">Goods</option>
          <option value="P">People</option>
          <option value="P1">People One</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary">What is the TRN (Traffic Register Number) number? <span class="text-danger">*</span></label>
        <input 
          type="text" 
          class="form-control form-control-sm text-xs" 
          placeholder="Enter TRN number" 
          v-model="professional_drivers_license_data.trn_number"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { API_BASE_URL } from "@/config";
export default {
  name: 'ProfessionalDriversLicense',
  props: {
    service_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      professional_drivers_license_data: {
        id: "",
        pdp_type_code: '',
        trn_number: '',
      },
    }
  },
  methods: {
    /**
     * Validates the professional drivers license data.
     * @returns {boolean} True if valid, false otherwise.
     */
    validate_professional_drivers_license() {
      if (!this.professional_drivers_license_data.pdp_type_code) {
        Swal.fire({
          icon: "info",
          title: "Validation Error",
          text: "Please select a PDP type code.",
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        return false;
      }
      if (!this.professional_drivers_license_data.trn_number) {
        Swal.fire({
          icon: "info",
          title: "Validation Error",
          text: "Please enter a TRN number.",
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        return false;
      }
      return true;
    },
    /**
     * Handles the data submission for professional drivers license.
     * @returns {boolean} True if submission is successful, false otherwise.
     */
    handle_data_submit(){
      if (this.validate_professional_drivers_license()) {
        this.$emit("update_data", "professional_drivers_license", this.professional_drivers_license_data);
        return true;
      }
      return false;
    },
    fetch_data() {
      const token = localStorage.getItem("token");
      const workflow_id = localStorage.getItem("workflow_id") || null;
      if (!workflow_id) {
        console.error("Workflow ID is not set in localStorage.");
        return;
      }

      const params = new URLSearchParams({
        workflow_id: workflow_id,
        service_id: this.service_id
      });

      fetch(
        `${API_BASE_URL}/verify_api/employee_screening/api/get_sections_by_workflow_client/?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success" && data.data && data.data.sections && data.data.sections.length > 0) {
            // Find the section for Professional Driver License Check (or use the first section)
            const section = data.data.sections.find(
              s => s.service_name === "Professional Driver License Check"
            ) || data.data.sections[0];

            // Flatten key_mappings into an object
            let license = {};
            let key_group = {};
            if (
              section &&
              section.key_groups &&
              section.key_groups.length > 0 &&
              section.key_groups[0].key_mappings
            ) {
              key_group = section.key_groups[0];
              section.key_groups[0].key_mappings.forEach(mapping => {
                license[mapping.key_name] = mapping.key_value;
              });
            }
            // Set data
            this.professional_drivers_license_data.id = key_group.id || "";
            this.professional_drivers_license_data.pdp_type_code = license.pdp_type_code || "";
            this.professional_drivers_license_data.trn_number = license.trn_number || "";
          } else {
            // Reset fields if no data
            this.professional_drivers_license_data = {
              id: "",
              pdp_type_code: '',
              trn_number: '',
            };
          }
        })
        .catch((error) => {
          console.error("Error fetching professional drivers license data:", error);
        });
    },
  },
  mounted() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.service-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f3f4;
}

.form-label {
  margin-bottom: 0.25rem;
}

.form-control-sm {
  padding: 0.375rem 0.5rem;
}
</style>
